import React, { useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';

const CommonButton = ({ children, onClick, variant = 'primary', className, style, title, loading, disabled, isValid, type = 'button' }) => {
  const [isHovered, setIsHovered] = useState(false);

  const getBackgroundColor = () => {
    if (variant === 'secondary') return isHovered ? '#f8f9fa' : '#fff';
    if (loading || disabled || isValid === false) return '#E0E0E0';
    return isHovered ? '#004040' : '#005457';
  };

  const getTextColor = () => {
    if (variant === 'secondary') return '#000';
    if (loading || disabled || isValid === false) return '#9E9E9E';
    return '#fff';
  };

  const getBorder = () => {
    if (variant === 'secondary') return '2px solid #000';
    return 'none';
  };

  return (
    <Button
      type={type}
      variant={variant === 'primary' ? 'primary' : 'light'}
      onClick={onClick}
      disabled={loading || disabled || isValid === false}
      onMouseEnter={() => !loading && !disabled && setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={`common-btn d-flex align-items-center justify-content-center ${className}`}
      style={{
        borderRadius: '8px',
        fontWeight: '700',
        fontSize: '14px',
        padding: '10px 24px',
        transition: 'all 0.2s ease',
        marginBottom: '0px',
        backgroundColor: getBackgroundColor(),
        color: getTextColor(),
        border: getBorder(),
        cursor: loading || ((disabled || isValid === false) && !isHovered) ? 'not-allowed' : 'pointer',
        ...style
      }}
      title={title}
      aria-label={title || undefined}
    >
      {loading ? (
        <>
          <Spinner animation="border" size="sm" className="me-2" role="status" />
          <span>Processing...</span>
        </>
      ) : (
        children
      )}
    </Button>
  );
};

CommonButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  variant: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  title: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  isValid: PropTypes.bool,
  type: PropTypes.string
};

export default CommonButton;
